import { Injectable, inject } from '@angular/core';
import { AuthFacade, UserActions } from '@campus/public-portal';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { switchMap, take, tap } from 'rxjs/operators';
import { RedirectService } from '../../services/redirect.service';

@Injectable()
export class AppUserEffects {
  private actions$ = inject(Actions);
  private redirect = inject(RedirectService);
  private auth = inject(AuthFacade);

  loginUserSuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(UserActions.USER_LOGIN_SUCCESS),
        switchMap(() => this.auth.getCurrent().pipe(take(1))),
        tap((user) => this.redirect.toPlatform(user))
      ),
    { dispatch: false }
  );
}
